<template lang="pug">
  .chat-widget-container(v-if="selectedWidget")
    component(ref="widget" :is="selectedWidget")
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "ChatWidget",

  components: {
    'GladlyWidget': () => import('@components/GladlyWidget'),
    'ZendeskWidget': () => import('@components/ZendeskWidget'),
  },

  computed: {
    ...mapGetters('chatWidget', ['implementationName']),

    selectedWidget() {
      if (!this.implementationName || (window && window.contentData && window.contentData.hideChatWidget)) {
        return null;
      }

      let registeredComponentNames = Object.keys(this.$options.components);

      let result = registeredComponentNames.find(componentName => componentName.toLowerCase().includes(this.implementationName.toLowerCase()));

      return this.$options.components[result];
    }
  },
};
</script>